export type PowerLevelType = {
  solutionRovider: any;
  deviceSdk: any;
};

export type PowerLevelResType = {
  charging: boolean; // 是否正在充电
  full: boolean; // 是否充满电
  level: number; // 电量等级 (范围: 0 ~ 100)
  workMode: number; // 工作模式：0 = USB，1 = 蓝牙（BT），2 = 2.4G 无线
};
export const usePowerLevel = (props: PowerLevelType) => {
  const { solutionRovider, deviceSdk } = props;
  const powerLevel: PowerLevelResType = {
    charging: false,
    full: false,
    level: 0,
    workMode: 0,
  };
  const getPowerLevel = async () => {
    if (solutionRovider === "xingshan") {
      return await getXingshanPowerLevel();
    }
    if (solutionRovider === "huafenda") {
      return await getHuafendaPowerLevel();
    }
    if (solutionRovider === "beiying") {
      return await getBeiyingPowerLevel();
    }
    if (solutionRovider === "jiangmeng") {
      return await getJiangmengPowerLevel();
    }
    if (solutionRovider === "ZHWX") {
      return await getZhwxPowerLevel();
    }
  };
  const getXingshanPowerLevel = async () => {
    return powerLevel;
  };

  const getHuafendaPowerLevel = async () => {
    const tryGetBattery = async () => {
      try {
        const deviceInfo = await deviceSdk.getDeviceInfo();
        if (!deviceInfo) return null;
        const level =
          typeof deviceInfo.batteryLevel === "number"
            ? deviceInfo.batteryLevel
            : 0;
        return {
          charging: !!deviceInfo.chargeStatus,
          full: level === 100,
          level,
          workMode: deviceInfo.workMode ?? 0,
        };
      } catch {
        return null;
      }
    };

    let last: PowerLevelResType | null = null;
    for (let i = 0; i < 4; i++) {
      if (i > 0) await new Promise((r) => setTimeout(r, 500));
      const result = await tryGetBattery();
      if (result && result.level > 0) return result;
      last = result;
    }
    return last ?? powerLevel;
  };

  const getBeiyingPowerLevel = async () => {
    try {
      if (!deviceSdk?.instance?.getBatteryStatus) {
        return powerLevel;
      }
      return await deviceSdk.instance.getBatteryStatus();
    } catch {
      return powerLevel;
    }
  };

  const getZhwxPowerLevel = async (): Promise<PowerLevelResType> => {
    const tryGetBattery = async () => {
      try {
        if (!deviceSdk?.getBatteryStatus) return null;
        const res = await deviceSdk.getBatteryStatus();
        const data = res?.data;
        if (!data || typeof data.level !== "number") return null;
        return {
          charging: !!data.charging,
          full: !!data.full || (data.level >= 100 && !data.charging),
          level: Math.min(100, Math.max(0, data.level)),
          workMode: data.workMode ?? 2,
        };
      } catch {
        return null;
      }
    };

    let last: PowerLevelResType | null = null;
    for (let i = 0; i < 4; i++) {
      if (i > 0) await new Promise((r) => setTimeout(r, 500));
      const result = await tryGetBattery();
      if (result && result.level > 0) return result;
      last = result;
    }
    return last ?? powerLevel;
  };

  const getJiangmengPowerLevel = async (): Promise<PowerLevelResType> => {
    if (!deviceSdk) return powerLevel;
    const battery = deviceSdk.getBattery?.();
    const fullInfo = deviceSdk.getDeviceInfoFull?.() ?? null;
    if (!battery) return powerLevel;
    const isWired = fullInfo?.isWired ?? false;
    return {
      charging: battery.charging ?? false,
      full: (battery.level ?? 0) === 100,
      level: Math.min(100, Math.max(0, battery.level ?? 0)),
      workMode: isWired ? 0 : 2, // 0 = USB 有线，2 = 2.4G 无线
    };
  };

  return getPowerLevel();
};
